import { gql } from '@apollo/client';

export const typeDefs = gql`
  # Put local schema here (either for mocking purposes or local state)
  type placeholder {
    id: ID!
  }
`;
